import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-3bf32d0a")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("保存")
_popScopeId()

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_input = _resolveComponent("a-input")
  const _component_a_form_item = _resolveComponent("a-form-item")
  const _component_info_circle_outlined = _resolveComponent("info-circle-outlined")
  const _component_a_tooltip = _resolveComponent("a-tooltip")
  const _component_a_select = _resolveComponent("a-select")
  const _component_SearchOutlined = _resolveComponent("SearchOutlined")
  const _component_a_input_number = _resolveComponent("a-input-number")
  const _component_upload_song = _resolveComponent("upload-song")
  const _component_select_book = _resolveComponent("select-book")
  const _component_UploadMultiVoice = _resolveComponent("UploadMultiVoice")
  const _component_a_form = _resolveComponent("a-form")
  const _component_a_col = _resolveComponent("a-col")
  const _component_upload_poster = _resolveComponent("upload-poster")
  const _component_upload_sheet = _resolveComponent("upload-sheet")
  const _component_upload_evms_sheet = _resolveComponent("upload-evms-sheet")
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_row = _resolveComponent("a-row")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, {
          xs: 24,
          sm: 24,
          md: 24,
          lg: 24,
          xl: 16
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form, {
              ref: "formRef",
              model: $setup.formData,
              labelCol: $setup.labelCol,
              wrapperCol: $setup.wrapperCol
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_form_item, {
                  name: "name",
                  label: "歌曲名称",
                  rules: [{ required: true, message: '请输入歌曲名称' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: $setup.formData.name,
                      "onUpdate:value": _cache[0] || (_cache[0] = $event => ($setup.formData.name = $event))
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                ($setup.route.params.type === '1')
                  ? (_openBlock(), _createBlock(_component_a_form_item, {
                      key: 0,
                      name: "song_code",
                      label: "歌曲识别码",
                      rules: [{ required: true, validator: $setup.codeLengthValidate }]
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: $setup.formData.song_code,
                          "onUpdate:value": _cache[1] || (_cache[1] = $event => ($setup.formData.song_code = $event)),
                          disabled: $setup.isEdit
                        }, {
                          suffix: _withCtx(() => [
                            ($setup.hasSameCode)
                              ? (_openBlock(), _createBlock(_component_a_tooltip, {
                                  key: 0,
                                  title: "存在相同的歌曲识别码",
                                  "default-visible": ""
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_info_circle_outlined, { style: {"color":"rgb(233, 103, 33)"} })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["value", "disabled"])
                      ]),
                      _: 1
                    }, 8, ["rules"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_form_item, {
                  name: "py",
                  label: "歌曲简拼",
                  rules: [{ required: true, message: '请输入歌曲简拼' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: $setup.formData.py,
                      "onUpdate:value": _cache[2] || (_cache[2] = $event => ($setup.formData.py = $event))
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  name: "song_type",
                  label: "歌曲类型",
                  rules: [{ required: true, message: '请选择歌曲类型' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      value: $setup.formData.song_type,
                      "onUpdate:value": _cache[3] || (_cache[3] = $event => ($setup.formData.song_type = $event)),
                      options: $setup.SheetSongTypeList
                    }, null, 8, ["value", "options"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  name: "sheet_type",
                  label: "谱例类型",
                  rules: [{ required: true, message: '请选择谱例类型' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      value: $setup.formData.sheet_type,
                      "onUpdate:value": _cache[4] || (_cache[4] = $event => ($setup.formData.sheet_type = $event)),
                      options: $setup.SheetTypeList
                    }, null, 8, ["value", "options"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, { label: "标签" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select, {
                      style: {"width":"95%"},
                      value: $setup.tagList,
                      "onUpdate:value": _cache[5] || (_cache[5] = $event => ($setup.tagList = $event)),
                      options: $setup.tagOpt,
                      mode: "multiple",
                      onSearch: $setup.handleSerach
                    }, null, 8, ["value", "options", "onSearch"]),
                    _createVNode(_component_SearchOutlined, { class: "serach_icon" })
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  name: "speed",
                  label: "歌曲速度",
                  rules: [{ required: true, message: '请输入歌曲速度' }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input_number, {
                      style: {"width":"100%"},
                      value: $setup.formData.speed,
                      "onUpdate:value": _cache[6] || (_cache[6] = $event => ($setup.formData.speed = $event)),
                      min: 0,
                      step: 0.1
                    }, null, 8, ["value", "step"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  name: "ori_file",
                  label: "原唱文件"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_upload_song, {
                      type: "ori",
                      formData: $setup.formData,
                      onOnChange: $setup.handleUploadFormChange
                    }, null, 8, ["formData", "onOnChange"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  name: "ori_file_url",
                  label: "原唱文件地址"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: $setup.formData.ori_file_url,
                      "onUpdate:value": _cache[7] || (_cache[7] = $event => ($setup.formData.ori_file_url = $event)),
                      disabled: true
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  name: "ori_file_size",
                  label: "原唱文件大小"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: $setup.formData.ori_file_size,
                      "onUpdate:value": _cache[8] || (_cache[8] = $event => ($setup.formData.ori_file_size = $event)),
                      disabled: true
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  name: "ori_file_md5",
                  label: "原唱文件MD5"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: $setup.formData.ori_file_md5,
                      "onUpdate:value": _cache[9] || (_cache[9] = $event => ($setup.formData.ori_file_md5 = $event)),
                      disabled: true
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  name: "acc_file",
                  label: "伴唱文件"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_upload_song, {
                      type: "acc",
                      formData: $setup.formData,
                      onOnChange: $setup.handleUploadFormChange
                    }, null, 8, ["formData", "onOnChange"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  name: "acc_file_url",
                  label: "伴唱文件地址"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: $setup.formData.acc_file_url,
                      "onUpdate:value": _cache[10] || (_cache[10] = $event => ($setup.formData.acc_file_url = $event)),
                      disabled: true
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  name: "acc_file_size",
                  label: "伴唱文件大小"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: $setup.formData.acc_file_size,
                      "onUpdate:value": _cache[11] || (_cache[11] = $event => ($setup.formData.acc_file_size = $event)),
                      disabled: true
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  name: "acc_file_md5",
                  label: "伴唱文件MD5"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      value: $setup.formData.acc_file_md5,
                      "onUpdate:value": _cache[12] || (_cache[12] = $event => ($setup.formData.acc_file_md5 = $event)),
                      disabled: true
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, {
                  name: "acc_speed",
                  label: "伴奏速度",
                  rules: [{ required: true, validator: $setup.accSongSpeedValidate }]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input_number, {
                      value: $setup.formData.acc_speed,
                      "onUpdate:value": _cache[13] || (_cache[13] = $event => ($setup.formData.acc_speed = $event)),
                      step: 0.1,
                      style: {"width":"100%"},
                      min: 0
                    }, null, 8, ["value", "step"])
                  ]),
                  _: 1
                }, 8, ["rules"]),
                _createVNode(_component_a_form_item, {
                  name: "book_info",
                  label: "教材选择"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_select_book, {
                      value: $setup.bookInfo,
                      bookName: $setup.bookName,
                      sectionName: $setup.sectionName,
                      onOnBookSelcetOk: $setup.handleSelectBook
                    }, null, 8, ["value", "bookName", "sectionName", "onOnBookSelcetOk"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, { label: "教材名称/章节" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_input, {
                      disabled: true,
                      value: $setup.bookNameInput,
                      "onUpdate:value": _cache[14] || (_cache[14] = $event => ($setup.bookNameInput = $event))
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_form_item, { label: "分声部范唱音频" }, {
                  default: _withCtx(() => [
                    true
                      ? (_openBlock(), _createBlock(_component_UploadMultiVoice, {
                          key: 0,
                          formData: $setup.formData,
                          onOnChange: $setup.handleUploadFormChange
                        }, null, 8, ["formData", "onOnChange"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "labelCol", "wrapperCol"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, {
          xs: 24,
          sm: 24,
          md: 24,
          lg: 24,
          xl: 8
        }, {
          default: _withCtx(() => [
            _createVNode(_component_upload_poster, {
              ref: "uploadPosterRef",
              form: $setup.formData,
              onOnChange: $setup.handleUploadFormChange
            }, null, 8, ["form", "onOnChange"]),
            _createVNode(_component_upload_sheet, {
              form: $setup.formData,
              onOnChange: $setup.handleUploadFormChange
            }, null, 8, ["form", "onOnChange"]),
            _createVNode(_component_upload_evms_sheet, {
              form: $setup.formData,
              onOnChange: $setup.handleUploadFormChange
            }, null, 8, ["form", "onOnChange"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_col, {
          offset: 11,
          xs: 24,
          sm: 24,
          md: 24,
          lg: 24,
          xl: 24
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: $setup.onSubmit
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}